export default __webpack_public_path__ + "static/media/not-found.23d4e1b4.jpg";